import { render, staticRenderFns } from "./PieEchart2.vue?vue&type=template&id=dae576f8"
import script from "./PieEchart2.vue?vue&type=script&lang=js"
export * from "./PieEchart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports